var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckLineGray2424 = function SvgCheckLineGray2424(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9BBBC",
    fillRule: "evenodd",
    d: "M18.28 7.517a.75.75 0 0 1 0 1.06l-7.906 7.906a.75.75 0 0 1-1.06 0L5.72 12.89a.75.75 0 0 1 1.06-1.061l3.064 3.063 7.376-7.375a.75.75 0 0 1 1.06 0",
    clipRule: "evenodd"
  })));
};
export default SvgCheckLineGray2424;